import type { IssueRow } from "#app/lib/data";
import { useFavoriteIssues } from "#app/lib/hooks/use-favorite-issues";
import { useIssueView } from "#app/components/issue-view";
import { useCloseSidebarIfMobile } from "#app/lib/mobile-sidebar-context";
import { useWorkspace } from "#app/lib/data/workspace-context";
import { SidebarSection } from "@salestrak/ui";
import { FavoriteItem } from "../favorite-item";

/**
 * "Favorites" module-menu section — the user's favorited issues. Shared by the
 * Home and Workflows module menus. Renders nothing when there are no favorites;
 * instances also drop it from their section list in that case so ModuleMenu
 * doesn't draw a stray divider.
 */
export function FavoritesSection() {
  const { activeWorkspace } = useWorkspace();
  const { issues: favoriteIssues, removeFavorite } = useFavoriteIssues();
  const { openIssueById } = useIssueView();
  const closeSidebar = useCloseSidebarIfMobile();

  if (favoriteIssues.length === 0) return null;

  return (
    <SidebarSection title="Favorites">
      {favoriteIssues.map((issue: IssueRow, index: number) => (
        <FavoriteItem
          copyUrl={`${typeof window !== "undefined" ? window.location.origin : ""}/${activeWorkspace?.urlPath ?? ""}/workflow/${issue.workflowId}?issue=${issue.issueId}`}
          isActive={false}
          issue={issue}
          key={`${issue.issueId}-${index}`}
          onClick={() => {
            closeSidebar();
            openIssueById(issue.issueId);
          }}
          onRemove={removeFavorite}
        />
      ))}
    </SidebarSection>
  );
}
